/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetClosableProducts200ResponseInnerProductsInner } from './GetClosableProducts200ResponseInnerProductsInner';
import {
    GetClosableProducts200ResponseInnerProductsInnerFromJSON,
    GetClosableProducts200ResponseInnerProductsInnerFromJSONTyped,
    GetClosableProducts200ResponseInnerProductsInnerToJSON,
    GetClosableProducts200ResponseInnerProductsInnerToJSONTyped,
} from './GetClosableProducts200ResponseInnerProductsInner';

/**
 * 
 * @export
 * @interface GetClosableProducts200ResponseInner
 */
export interface GetClosableProducts200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetClosableProducts200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetClosableProducts200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {Array<GetClosableProducts200ResponseInnerProductsInner>}
     * @memberof GetClosableProducts200ResponseInner
     */
    products: Array<GetClosableProducts200ResponseInnerProductsInner>;
}

/**
 * Check if a given object implements the GetClosableProducts200ResponseInner interface.
 */
export function instanceOfGetClosableProducts200ResponseInner(value: object): value is GetClosableProducts200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function GetClosableProducts200ResponseInnerFromJSON(json: any): GetClosableProducts200ResponseInner {
    return GetClosableProducts200ResponseInnerFromJSONTyped(json, false);
}

export function GetClosableProducts200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClosableProducts200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'products': ((json['products'] as Array<any>).map(GetClosableProducts200ResponseInnerProductsInnerFromJSON)),
    };
}

export function GetClosableProducts200ResponseInnerToJSON(json: any): GetClosableProducts200ResponseInner {
    return GetClosableProducts200ResponseInnerToJSONTyped(json, false);
}

export function GetClosableProducts200ResponseInnerToJSONTyped(value?: GetClosableProducts200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'products': ((value['products'] as Array<any>).map(GetClosableProducts200ResponseInnerProductsInnerToJSON)),
    };
}

